angular.module('leanlaw').controller('AttorneyRevenueInvoicesCtrl', ['$scope', '$rootScope', '$timeout', '$q', '$filter', '$window', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'leanLawAuth', 'leanLawApi', 'accountingService', "exportJson", "messageBus", 'ModalService', 'singleRequest', 'viewInvoiceService', function ($scope, $rootScope, $timeout, $q, $filter, $window, $state, $stateParams, alerts, userService, reportsService, leanLawAuth, leanLawApi, accountingService, exportJson, messageBus, ModalService, singleRequest, viewInvoiceService) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    $window.print();
  };
  $scope.showInvoice = showInvoice;
  $scope.showDraft = showDraft;
  $scope.showAllocation = showAllocation;
  $scope.openInvoice = openInvoice;
  $scope.openPayment = openPayment;
  $scope.back = back;
  $scope.viewInvoiceSummary = viewInvoiceSummary;
  $scope.backPages = -1;
  $scope.export = function () {
    const exp = $scope.data.filtered.reduce((accum, c) => {
      const item = {
        Invoice: c.invoice.reference,
        "Payment Date": $filter("dateLogical")(c.payment.date),
        Amount: $filter("amount")(c.data.collected.servicesTotal),
        Client: c.client.name,
        Worked: $filter("amount")(c.data.collected.servicesTotal)
      };
      item["Worked Share"] = $filter("amount")(c.data.origination.share);
      item.Origination = $filter("amount")(c.data.origination.originatorDebit);
      if ($scope.me.company.settings.report?.responsibleContribution) {
        item.Responsible = $filter("amount")(c.data.origination.responsibleDebit);
      }
      if ($scope.me.features.referral) {
        item.Referrals = $filter("amount")(c.data.origination.referralDebit);
      }
      if ($scope.me.company.settings.report?.customPlan) {
        item["Firm Share"] = $filter("amount")(c.data.origination.firmDebit);
      }
      item.Total = $filter("amount")(c.data.origination.adjusted);
      if ($scope.filter.showExpense) {
        item.Expenses = $filter("amount")(c.data.collected.expensesUsers);
      }
      if ($scope.me.features.referral && $scope.data.data.collected.expensesServices) {
        item["Service Expenses"] = $filter("amount")(c.data.collected.expensesServices);
      }
      accum.push(item);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    $q.all([userService.me(), leanLawApi.getAccount({
      id: $stateParams.accountId
    })]).then(([me, user]) => {
      $scope.me = me;
      $scope.user = user;
      setOriginationSettings();
      accountingService.verify(false).then(status => {
        $scope.accounting = status.connected;
        $scope.$on('commonFilterService-statechanged', (event, payload) => {
          if (!payload) return;
          // Assigning to existing filter keeps custom filter options
          $scope.filter = Object.assign($scope.filter, payload);
          // Necessary to set this value for the requests
          $scope.filter.status = $scope.filter.archived.status;
          $scope.filter.scope = $scope.filter.filter.scope;
          if (payload.filter.range) {
            filterClientEntries();
          }
        });
        $scope.$on("report-sidebar-filterchange", (event, payload) => {
          $scope.filter = Object.assign($scope.filter, payload);
        });

        // MessageBus is used here so that the commonFilter module can pick it up once it loads
        messageBus.addMessage("filterDependency-ready", true);
      });
    });
  }
  let _cancelReport = null;
  function filterClientEntries() {
    if (_cancelReport) {
      _cancelReport.resolve("reloading");
    }
    _cancelReport = $q.defer();
    const query = reportsService.queryFromFilter($scope.filter);
    query.account = $scope.user.id;
    query.data = "payments";
    query.billed = 'any';
    query.billedState = undefined;
    query.billingType = '-internal';
    query.primary = 'clients';
    query.zeros = false;
    query.detail = 'payments';
    query.$timeout = _cancelReport.promise;
    query.clientId = $stateParams.clientId;
    query.matterId = $stateParams.matterId;
    query.accountId = $stateParams.accountId;
    query.reportType = 'revenue';
    $scope.loading = true;
    singleRequest.apiCall("report").getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.loading = false;
      $scope.data = data;
      const invoicePayments = [];
      data.clients.forEach(client => {
        client.data.detail.invoicePayments.forEach(ip => {
          invoicePayments.push({
            ...ip,
            client: client.client
          });
        });
      });
      $scope.data.invoicePayments = invoicePayments;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  function setOriginationSettings() {
    if ($stateParams.matterId) {
      leanLawApi.getMatter({
        id: $stateParams.matterId
      }).then(matter => {
        if (!matter) return;
        $scope.matter = matter;
        $scope.shareUser = matter.users.find(account => account.id === $stateParams.accountId);
      });
    }
    if ($stateParams.clientId) {
      leanLawApi.getClient({
        id: $stateParams.clientId
      }).then(client => {
        if (!client) return;
        $scope.client = client;
      });
    }
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  function showInvoice(invoice) {
    const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
    $window.open(url);
  }
  function showDraft(invoice) {
    viewInvoiceService.viewInvoice(invoice, false);
  }
  function showAllocation(invoicePayment) {
    $timeout(() => {
      $(".modal-backdrop.in").remove();
      // This won't flash because the backdrop is hidden
      // This simply removes the elements so they don't stack up once
      // the body doesn't have the "show-modal-overlay" class
    }, 50);
    return ModalService.showModal({
      template: require("../../../modals/allocation/template.html"),
      inputs: {
        params: {
          invoicePayment
        }
      },
      bodyClass: "show-modal-overlay",
      controller: "AllocationModalController"
    }).then(modal => {
      modal.element.modal();
      modal.close.then(() => {
        // Remove modal-open class from body which breaks print
        $("body").removeClass("modal-open");
      });
    });
  }
  function viewInvoiceSummary(invoice) {
    $scope.backPages -= 2;
    $state.go(`reports.attorney-revenue-invoices.invoiceSummary`, {
      id: invoice.id
    });
  }
  function openInvoice(invoice) {
    const url = `${$scope.me.configuration.quickbooks}/app/invoice?txnId=${invoice.accounting.id}`;
    $window.open(url, '_blank');
  }
  function back() {
    $window.history.go($scope.backPages);
    //$state.go("reports.attorney-revenue-detail", { id: $stateParams.accountId });
  }
  function openPayment(payment) {
    const url = `${$scope.me.configuration.quickbooks}/app/recvpayment?txnId=${payment.accounting.id}`;
    $window.open(url, '_blank');
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.invoicePayments, $scope.q), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.invoicePayments', updateFiltered);
  $scope.$watch('q', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);